import { render, staticRenderFns } from "./CurrentJobs.vue?vue&type=template&id=a483a3b4"
import script from "./CurrentJobs.vue?vue&type=script&lang=js"
export * from "./CurrentJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports